// Language and Level Mapping Utilities

export const languageMap = {
  'de': 'German',
  'en': 'English',
  'fr': 'French',
  'es': 'Spanish',
  'it': 'Italian',
  'ja': 'Japanese',
  'german': 'German',
  'english': 'English',
  'french': 'French',
  'spanish': 'Spanish',
  'italian': 'Italian',
  'japanese': 'Japanese'
};

export const levelMap = {
  'beginner-a1': 'A1',
  'elementary-a2': 'A2',
  'pre-intermediate-b1': 'B1',
  'intermediate-b2': 'B2',
  'advanced-c1': 'C1',
  'proficient-c2': 'C2',
  'beginner': 'A1',
  'elementary': 'A2',
  'pre-intermediate': 'B1',
  'intermediate': 'B2',
  'upper-intermediate': 'B2',
  'advanced': 'C1',
  'proficient': 'C2',
  'a1': 'A1',
  'a2': 'A2',
  'b1': 'B1',
  'b2': 'B2',
  'c1': 'C1',
  'c2': 'C2',
  // Japanese JLPT levels (matching LanguageContext keys)
  'beginner-n5': 'N5',
  'elementary-n4': 'N4',
  'pre-intermediate-n3': 'N3',
  'intermediate-n2': 'N2',
  'advanced-n1': 'N1',
  'n5': 'N5',
  'n4': 'N4',
  'n3': 'N3',
  'n2': 'N2',
  'n1': 'N1'
};

export const mapLanguage = (language) => {
  return languageMap[language.toLowerCase()] || language;
};

export const mapLevel = (proficiencyLevel) => {
  let mapped = levelMap[proficiencyLevel.toLowerCase()];
  if (!mapped) {
    // Extract level code from string like "PRE-INTERMEDIATE-B1" -> "B1" or "BEGINNER-N5" -> "N5"
    const match = proficiencyLevel.match(/([ABC][12]|N[1-5])/i);
    mapped = match ? match[1].toUpperCase() : proficiencyLevel.toUpperCase();
  }
  return mapped;
};

// Get "Questions" label translated to the selected language
// Returns object with native and english text to avoid "Questions (Questions)" for French/English
export const getQuestionsLabel = (language) => {
  const lang = (language || '').toLowerCase();
  const labels = {
    de: 'Fragen', german: 'Fragen', deutsch: 'Fragen',
    fr: 'Questions', french: 'Questions', français: 'Questions',
    es: 'Preguntas', spanish: 'Preguntas', español: 'Preguntas', espanol: 'Preguntas',
    it: 'Domande', italian: 'Domande', italiano: 'Domande',
    ja: '質問', japanese: '質問',
    en: 'Questions', english: 'Questions',
  };
  const native = labels[lang] || 'Questions';
  // Only append English if the native word is different
  if (native === 'Questions') return 'Questions';
  return `${native} (Questions)`;
};
